import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { showErrorNotification } from "actions/action-complete-notificator";
import { useLogOutClientAccountMutation, clientAccountApi } from 'actions/client/client-account-api'
import { translationApi } from 'actions/translation-api';
import { PATH_CHANGE_PASSWORD } from 'routing/path'

const Navbar = () => {
	const [ logOut, { isLoading: logOutInProgress } ] = useLogOutClientAccountMutation();
  const currentClientAccount = useSelector(clientAccountApi.endpoints.getCurrentClientAccount.select()).data;
	const translations = useSelector(translationApi.endpoints.getTranslations.select()).data ?? {};

	const submitDisabled = logOutInProgress;
  const handleSubmit = async () => {
    const result = await logOut();
    if ('error' in result) {
      showErrorNotification(result.error);
    }
  };

  const userName = currentClientAccount ? currentClientAccount.firstName + " " + currentClientAccount.lastName : "";
  return (
    <nav className="navbar navbar-top navbar-expand navbar-dashboard navbar-dark pl-0 pr-2 pb-0">
      <div className="container-fluid px-0">
        <div className="d-flex justify-content-between w-100" id="navbarSupportedContent">
          <div className="d-flex">
          </div>
          <ul className="navbar-nav align-items-center">
            <li className="nav-item dropdown">
              <div className="nav-link dropdown-toggle pt-1 px-0" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <div className="media d-flex align-items-center">
                  <FontAwesomeIcon icon={faUserCircle} className="user-image-fa" size="lg" />
                  <div className="media-body ms-2 text-dark align-items-center d-none d-lg-block">
                    <span className="mb-0 font-small fw-bold">{userName}</span>
                  </div>
                </div>
              </div>
              <div className="dropdown-menu dashboard-dropdown dropdown-menu-end mt-2 py-0">
                <Link className="dropdown-item rounded-top fw-bold" to={PATH_CHANGE_PASSWORD}>{translations.changePassword}</Link>
                <div role="separator" className="dropdown-divider my-0"></div>
                <Formik
                  initialValues={() => {}}
                  onSubmit={ async () => { await handleSubmit() }}>
                  {() => (<Form>
                    <button id="signOutButton" type="submit" className="dropdown-item rounded-bottom fw-bold" disabled={submitDisabled ? 'disabled' : null}><FontAwesomeIcon icon={faSignOutAlt} /> {translations.signOut}</button>
                  </Form>)}
                </Formik>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
